// extracted by mini-css-extract-plugin
export default {"button":"buttonCheckout_button__F4S94"};